import React from 'react';
import { fetchTermYear } from '../services/options_service';
import { InputTypeDropdown } from '.';

class InputDropdownTermYear extends React.Component {
  state = {
    options: [],
  };

  componentDidMount() {
    this.fetchTermYear();
  }

  fetchTermYear = () => {
    fetchTermYear().then((data) => {
      this.setState({
        options: data,
      });
    });
  };

  render() {
    const { ...rest } = this.props;
    const { options } = this.state;

    return (
      <InputTypeDropdown
        field="term_year"
        label="Etapa x Ano"
        options={options}
        {...rest}
      />
    );
  }
}

export default InputDropdownTermYear;
